.b2{padding:0.5rem;}